import React, { useState, useEffect } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Facebook from '../components/Facebook';
import Google from '../Google';
import { gapi } from "gapi-script";
import {loginvariable} from '../config/Variables';
import Header from '../partials/Header';


//import Google from './components/Google';
function Login() {
  const [password, setPassword] = useState();
  const [email, setEmail] = useState(useParams().email);
  const [messagelog, setMessagelog] = useState("");
  const device_name = 'nokia';
 // const { emailparm } = useParams();

  // const history = useNavigate();
  const navigate = useNavigate();

  const handleKeyPress = (evnt) => {
    if (evnt.key === 'Enter') {
      login();
    }

  }
  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: process.env.REACT_PUBLIC_GOOGLE_CLIENT_ID,
        scope: 'email',
      });
    }

    gapi.load('client:auth2', start);

    if (localStorage.getItem('user-info')) {
      // history("/add");
      //  navigate('/sample');
      return <Navigate to="/personalize" />
      //console.warn("iam login");
      document.title = `Journey`;
    }

  }, []);
  if (localStorage.getItem('user-info')) {
  //  window.location.href = 'https://srpcawsatdev.prod.acquia-sites.com/';
    var domainurl=  window.location.origin;
    window.location.href = domainurl;
    return null
  }
  const handleCheckChange = (evnt) => {
    if (evnt === 'successsfirstfacebook') {
    
      var domainurl=  window.location.origin;
      window.location.href = domainurl+'/#/personalize';
    }
    if (evnt === 'successssecondfacebook') {

      var domainurl=  window.location.origin;
      window.location.href = domainurl+'/#/personalize';
    }

  }
  function forgetpassword() {

    if(email){
      window.location.href = '#/forget_password/'+email;
    }else{
      window.location.href = '#/forget_password';
    }
   
  }
  async function login() {
    
    if (!email) {
      setMessagelog('الارجاء ادخال البريد الالكتروني  قبل التسجيل');
    }else if (!password) {
      setMessagelog('الارجاء ادخال كلمة السر  قبل التسجيل');
    } else {
      let item = { email, password, device_name };
      let result = await fetch(loginvariable, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": 'application/json'
        },
        body: JSON.stringify(item)
      });

      result = await result.json();
      if (result.message.code == '200') {
          window.dataLayer = window.dataLayer || [];
    
          window.dataLayer.push({
          event: 'login',
          user_id: result.user.id,
          method: "email"
          });

        localStorage.setItem("user-info", JSON.stringify(result));
        //history('/add');
        var parts = window.location.search.substr(1).split("&");
        var $_GET = {};
        for (var i = 0; i < parts.length; i++) {
            var temp = parts[i].split("=");
            $_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
        }
        
        //alert($_GET['foo']); // 1
        //alert($_GET.bar);    // 2
        
        console.log($_GET['destination']);
        console.log("samir");
        var domainurl=  window.location.origin;
        if($_GET['destination']){
          
          window.location.href = domainurl+$_GET['destination'];
        }else{

        
      //var domainurl=  window.location.origin;
        window.location.href = domainurl;
        }
      }
      if (result.message.code == '0') {
        setMessagelog('هناك خطأ في كلمة المرور أو البريد الإلكتروني');
        // setMessagelog="testtttt";
        console.log(email)
      }
      return <Navigate to="/personalize" />
    }
  }

  if (localStorage.getItem('user-info')) {
    return (
      <div>
        You Are Login
      </div>
    );
  } else {
    return (
      <>
      <Header backhref="#/"  />
      <main>
<div class="grid-x align-center">


      <div className="cell shrink">
        <div className="form-area-wrap padding-vertical-3">
          <div className="section-title">
            <h3>تسجيل الدخول​</h3>
            <p>سجل الدخول لتحظى بآخر الأخبار​</p>
          </div>
          <div className="form-area">

            <div className="message alert text-center">
              {messagelog}
            </div>


            <div className="input-field">

              <span className="ico-label"><i className="icomoon-icon icon-envelop2"></i></span>
              <input type="email" name="email" onChange={(e) => setEmail(e.target.value)} placeholder="البريد الالكتروني" defaultValue={email} />
            </div>

            <div className="input-field">
              <span className="ico-label"><i className="icomoon-icon icon-lock"></i></span>
              <input type="password" name="password" onKeyDown={handleKeyPress} placeholder="كلمة المرور" onChange={(e) => setPassword(e.target.value)} />
 

            </div>
            <div className="text-center forgot-password"><button onClick={forgetpassword} >لاسترجاع كلمة المرور</button></div>

            <div className="text-center">
              <button onClick={login} className="button submit-btn" onKeyPress={login}  >تسجيل الدخول</button>
              <div className="custom-txt-style"><span>أو</span></div>
              <div className="form-socials-btns">


                <Facebook samirCallback={handleCheckChange} />
                <Google />

              </div>

            </div> </div>
        </div>


      </div>
      </div>
      </main>
      </>
    );
  }
}

export default Login;
